package es.subastia.gallery

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage
import es.subastia.navigation.Navigator
import org.jetbrains.compose.resources.stringResource
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.btn_close

@Composable
fun GalleryScreen(navigator: Navigator, imageUrl: String) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black)
    ) {
        // Full screen image with pinch to zoom would be ideal but for now simple fill
        // Note: For real pinch-to-zoom we'd need a library like Zoomable or custom gesture handling.
        // Keeping it simple as per "want to see it better".
        AsyncImage(
            model = imageUrl,
            contentDescription = null,
            contentScale = ContentScale.Fit,
            modifier = Modifier.fillMaxSize()
        )

        // Close Button
        IconButton(
            onClick = { navigator.pop() },
            modifier = Modifier
                .align(Alignment.TopEnd)
                .statusBarsPadding()
                .padding(16.dp)
        ) {
            Icon(
                imageVector = Icons.Default.Close,
                contentDescription = stringResource(Res.string.btn_close),
                tint = Color.White
            )
        }
    }
}
